export const notificationType = ["EMAIL","SMS" , "BOTH"] 
export const sendingType = ["INSTANT","END_OF_DAY","AFTER_SETTLEMENT"] 
export const direction = ["BOTH","INCOMING","OUTGOING"]
export const docType = ["PDF","WORD"]
export const saftyType = ["NORMAL","PROTECTED"]
export const customerType = ["INDIVIDUAL","GROUP"]
export const operatorOptionsAmount = ["LESS_THAN","EQUAL", "GREATER_THAN_OR_EQUAL","LESS_THAN_OR_EQUAL","GREATER_THAN"]
export const operatorOptionsText = ["EQUAL", "LIKE","NOT_EQUAL"]
export const operatorOptionsMatching = [{id:1 , name:"START_WITH"},{id:2,name:"END_WITH"},{id:3,name:"EQUAL"}]
export const FieldTypeDropdown = [{id:1,name:"MANDATORY"},{id:0,name:"OPTIONAL"}]